$(document).ready(function () {
    window.bvCallback = function (BV) {
        if (typeof BV !== 'undefined') {
                if (BV.reviews) {
        BV.reviews.on('show', function () {
            // This line assumes SFRA collapsible panels and is called when clicking on the review summary
            $('.row.reviews:not(.active)').toggleClass('active');
        });
    } else if (BV.swat_reviews) {
        BV.swat_reviews.on('show', function () {
            // This line assumes SFRA collapsible panels and is called when clicking on the review summary
            $('.row.reviews:not(.active)').toggleClass('active');
        });
    }
    if (BV.questions) {
        BV.questions.on('show', function () {
        // This line assumes SFRA collapsible panels and is called when clicking on the Q&A summary
            $('.row.questions:not(.active)').toggleClass('active');
        });
    } else if (BV.swat_questions) {
        BV.swat_questions.on('show', function () {
            // This line assumes SFRA collapsible panels and is called when clicking on the review summary
            $('.row.reviews:not(.active)').toggleClass('active');
        });
    }
        }
    };
    setTimeout(function () {
        document.getElementById('data-bv-show').style.display = 'block';
        var dataBvShow = document.getElementsByClassName("data-bv-show");
        for(var i = 0; i < dataBvShow.length; i++){
            dataBvShow[i].style.display = 'block';
        }
    }, 1500);
});
